export enum ROLES {
  OrganizationAdmin = "organization_admin",
  CommunityMember = "community_member",
  BusinessOwner = "business_owner",
}

export enum ORGANIZATION_TYPES {
  pta = 1,
}
